module.exports = __webpack_public_path__ + "media/src/img/detail-cloud-left-a4d42fbe5f454a63fa1353e663569857.png";